import React, { useEffect, useState } from "react";
import ContentPageTitle from "../../../../common/ContentPageTitle";
// import HelpButton from "../../../../common/HelpButton";
import { useManageCategories } from "../../../../hooks/useManageCategories";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Link } from "react-router-dom";
import { getServicesList } from "../../../../features/reducers/services";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import ProductsCategoriesSettings from "./ProductsCategoriesSettings";
import { Alert } from "antd";

export default function ManageCategories(props) {
  const { business } = props;

  // Initiate action to get user's business list
  const user = useSelector((state) => state.user.user);

  const dispatch = useDispatch();
  // const servicesList = useSelector((state) => {
  //   return state.services.servicesList;
  // });

  const [categoriesList, setCategoriesList] = useState([]);

  useEffect(() => {
    getCategoriesList();
  }, [business.id, dispatch]);

  const getCategoriesList = async () => {
    try {
      if (business.id) {
        const APIURL = `/api/restaurant/dish/categories/${business.id}`;
        const res = await axiosWithAuth().get(APIURL);
        setCategoriesList(res.data.data);
        console.log("res", res);
      }
    } catch (error) {
      console.log("Error getting categories: ", error);
    }
  };

  // Custom hook to manage the creation/deletion of business listing
  const hookData = {
    creatorID: business.id,
    dispatchAction: getCategoriesList,
    deleteItemAPI: "/api/products/delete",
    user: user,
    itemType: "categorie",
    type: "service",
    modalData: {
      title: "Create New Categorie",
      fieldLabel: "Categorie Name",
    },
  };

  const [modalComponent, CreateItemButton, ListComponent] =
    useManageCategories(hookData);

  return (
    <div id="services-page">
      <ContentPageTitle title="Product Categories" icon="file-pen" />

      <div className="content-box">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <ListComponent
                  emptyMessage="Seems like you don't have an service listing."
                  btnText="Create New Categorie"
                  listItems={categoriesList}
                />

                <CreateItemButton btnText="Create New Categorie" />
              </>
            }
            exact
          />

          <Route
            path="/:id"
            element={<ProductsCategoriesSettings business={business} />}
            exact
          />
        </Routes>
      </div>

      {modalComponent}
    </div>
  );
}
